import React, { useState } from 'react';
import ToolList from '../components/ToolList';
import ToolSearch from '../components/ToolSearch';
import './Home.css';
import AIChatAssistant from '../components/AIChatAssistant';

const Home = () => {
  const [filter, setFilter] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const handleFilter = (type) => {
    if (filter === type) {
      setFilter(null);
      setSelectedCategory(null);
    } else {
      setFilter(type);
      setSelectedCategory(null);
    }
  };

  return (
    <div className="home-page">
      <h2 className="section-title">Browse Tools</h2>

      <div className="filter-buttons">
        <button onClick={() => handleFilter('free')} className={filter === 'free' ? 'active' : ''}>
          Free Tools
        </button>
        <button onClick={() => handleFilter('paid')} className={filter === 'paid' ? 'active' : ''}>
          Paid Tools
        </button>
      </div>

      <ToolSearch onSearch={(query) => setSearchQuery(query)} />

      <ToolList 
        filter={filter} 
        category={selectedCategory} 
        setCategory={setSelectedCategory} 
        searchQuery={searchQuery} // pass search query to ToolList
      />
      <AIChatAssistant />
    </div>
  );
};

export default Home;
